<template>
  <div class="zw-completion">
    <div class="merchant info">
      <div class="merchant-logo">
        <img :src="activeMerchant.logo" :alt="activeMerchant.name">
      </div>
      <h1 class="merchant-name" v-html="activeMerchant.name"></h1>
      <div class="checkbox">
        <i class="checkmark icon"/>
      </div>
    </div>

    <div class="message">
      <h1 class="ui header">
        {{ $t('pages.setup.usersuccess.header') }}
      </h1>
      <p v-html="$t('pages.setup.usersuccess.message')"></p>
      <div class="ui blue button" @click="$router.push({name: 'dashboard'})">{{
          $t('pages.setup.usersuccess.button')
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserSuccess',

  layout: 'intro',

  computed: {
    activeMerchant() {
      return this.$store.getters.activeMerchant
    }
  }
}
</script>

<style lang="scss" scoped>
.zw-completion {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  color: #8B9690;
  width: 50%;
  box-shadow: -5px -2px 35px 0px rgba(0, 0, 0, 0.14), 4px 20px 35px rgba(0, 0, 0, 0.02);
  padding: 60px 120px;

  @media only screen and (max-width: 1200px) {
    width: 60%;
    padding: 80px;
  }

  @media only screen and (max-width: 768px) {
    width: 80%;
    padding: 60px;
  }

  @media only screen and (max-width: 425px) {
    width: 100%;
    height: 100%;
    padding: 20px;
  }

  .merchant.info {
    position: relative;
    padding: 15px;
    width: 70%;
    border: 2px dashed rgb(219, 229, 235);
    background: rgb(249, 250, 253);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;

    .merchant-name {
      margin: 0;
      text-align: center;
    }

    .checkbox {
      position: absolute;
      right: -20px;
      bottom: -20px;
      height: 50px;
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 50%;
      background: rgb(102, 186, 107);
      font-size: 20px;

      .icon {
        margin: 0;
        padding: 0;
        height: auto;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    padding: 40px 0;
    text-align: center;

    p {
      line-height: 30px;
    }

    .button {
      margin-top: 20px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/setup/UserSuccess.vue